import React from 'react'
import {ModalBase} from '../ModalBase'
import './modal-info.css'
import Info from '../../../media/felsv/SvgInfo.svg'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {generalCloseModalInfo} from '../../../actions/general.actions'
import { REGEX_HTML } from '../../../constants/Regex'

const ModalInfo = () => {
  const info: string = useSelector((state: State) => state.general.modalInfo.message)
  const dispatch = useDispatch()
  
  const htmlToJSX = (texto: string) => {
    if (texto && REGEX_HTML.test(texto)) return <div dangerouslySetInnerHTML={{__html: texto}}></div>    
    return texto
  }
  
  const close = () => dispatch(generalCloseModalInfo())

  return (
    <ModalBase Styles={{minWidth: '25%', maxWidth: '550px', backgroundColor: '#f1f1f1'}}>
      <div className='modal-info-buttons-fixed-top'>
        <div className='w-layout-hflex '>
          <h3 className='modal-info-title'>
            <img src={Info} alt='info' />
            &nbsp;&nbsp;&nbsp;AVISO
          </h3>
        </div>
        <div className='form-separator'></div>
      </div>
      <div className='modal-info-content'>
        <div className='modal-info-message'>
          <div dangerouslySetInnerHTML={{__html: info}}></div>
        </div>
      </div>
      <div className='modal-info-buttons-fixed-bottom'>
        <div className='w-layout-hflex button-actions'>
          <button autoFocus className='m button w-inline-block' onClick={close}>
            Aceptar
          </button>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalInfo
